

document.addEventListener("DOMContentLoaded", () => {
const swiper = new Swiper('.mySwiper1', {
  slidesPerView: 'auto',
  spaceBetween: 20,
  freeMode: true,
  loop: true,
  speed: 1000, // 1 second transition speed
  autoplay: {
    delay: 3000, // 3 seconds between slides
    disableOnInteraction: false, // keep autoplay after user interaction
  },
  mousewheel: {
    forceToAxis: true,
    invert: true,
  },
  keyboard: {
    enabled: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar-ugc",
    draggable: true,
  },
  breakpoints: {
    1024: {
      freeMode: false
    }
  }
});

  const slides = document.querySelectorAll('.mySwiper1 .swiper-slide');

  slides.forEach((slide) => {
    const video = slide.querySelector('video');
    const playBtn = slide.querySelector('.play-button-svg');

    slide.addEventListener('click', async () => {
      // Pause all other videos
      document.querySelectorAll('.mySwiper1 video').forEach(v => {
        if (v !== video && !v.paused) {
          v.pause();
          const btn = v.parentElement.querySelector('.play-button-svg');
          if (btn) btn.style.display = 'block';
        }
      });

      if (video.paused) {
        try {
          await video.play();
          playBtn.style.display = 'none';
        } catch (err) {
          console.warn('Video play failed:', err);
        }
      } else {
        video.pause();
        playBtn.style.display = 'block';
      }
    });
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        const video = entry.target.querySelector('video');
        const playBtn = entry.target.querySelector('.play-button-svg');
        if (video && !video.paused) {
          video.pause();
          if (playBtn) playBtn.style.display = 'block';
        }
      }
    });
  }, { threshold: 0.3 });

  slides.forEach(slide => observer.observe(slide));
});